export const ru = {
    cancel: 'Отмена'
};
